import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-exit",
  "use": "icon-icon-exit-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-exit\">\n<g id=\"icon-icon-exit_Group 427324098\">\n<g id=\"icon-icon-exit_Group 427324139\">\n<line id=\"icon-icon-exit_Line 1\" x1=\"9.63582\" y1=\"9.63603\" x2=\"22.3637\" y2=\"22.364\" stroke=\"#585860\" stroke-width=\"2\" />\n<line id=\"icon-icon-exit_Line 2\" x1=\"9.63591\" y1=\"22.364\" x2=\"22.3638\" y2=\"9.63605\" stroke=\"#585860\" stroke-width=\"2\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol